import { download } from "../config/download";


export const downloadExcel = (data) => {
    return download.excel(data).then(response => response)
  };
  export const downloadZip = (data) => {
    return download.zip(data).then(response => response)
  };